module.exports = __webpack_public_path__ + "images/stuffs/stuff-binoculars.svg";